import axios from './api';

export interface PaymentLogFilters {
  page?: number;
  limit?: number;
  userId?: string;
  orderId?: string;
  provider?: string;
  method?: string;
  action?: string;
  status?: string;
  authority?: string;
  refId?: string;
  fromDate?: string;
  toDate?: string;
  context?: string;
}

export interface PaymentLogsResponse {
  docs: any[];
  total: number;
  totalPages: number;
  page: number;
  limit: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}

export const paymentLogsService = {
  async list(filters: PaymentLogFilters = {}): Promise<PaymentLogsResponse | null> {
    try {
      const { page = 1, limit = 20, ...rest } = filters;

      // Filter out empty string values
      const cleanParams: any = { page, limit };
      Object.entries(rest).forEach(([key, value]) => {
        if (value && value !== '') {
          cleanParams[key] = value;
        }
      });

      console.log('Fetching payment logs with params:', cleanParams);

      // apiService.get already extracts nested data from { status, data: {...} }
      // So response is directly { docs, total, totalPages, ... }
      const response = await axios.get<PaymentLogsResponse>('/admin/payment-logs', { params: cleanParams });

      console.log('Payment logs response:', response);

      // Check if response has docs directly (apiService already extracted data)
      if (response && response.docs) {
        return response;
      }

      // Fallback for different response structure
      if (response && Array.isArray((response as any).data?.docs)) {
        return (response as any).data;
      }

      console.warn('Unexpected response format:', response);
      return {
        docs: [],
        total: 0,
        totalPages: 1,
        page: 1,
        limit: 20,
        hasNextPage: false,
        hasPrevPage: false
      };
    } catch (error: any) {
      console.error('Error fetching payment logs:', error?.response?.data || error?.message || error);
      return null;
    }
  },

  async get(id: string) {
    try {
      // apiService.get already extracts nested data
      const response = await axios.get(`/admin/payment-logs/${id}`);
      console.log('Payment log detail response:', response);

      // Response is already the extracted data
      if (response) {
        return response;
      }

      return null;
    } catch (error: any) {
      console.error('Error fetching payment log:', error?.response?.data || error?.message || error);
      return null;
    }
  },

  async getStats(params?: { fromDate?: string; toDate?: string }) {
    try {
      // apiService.get already extracts nested data
      const qs = params ? Object.entries(params).filter(([, v]) => !!v).map(([k, v]) => `${k}=${encodeURIComponent(String(v))}`).join('&') : '';
      const response = await axios.get(`/admin/payment-logs/stats${qs ? `?${qs}` : ''}`);
      console.log('Payment logs stats response:', response);

      // Response is already the extracted data
      if (response) {
        return response;
      }

      return null;
    } catch (error: any) {
      console.error('Error fetching payment logs stats:', error?.response?.data || error?.message || error);
      return null;
    }
  }
};

export default paymentLogsService;
